import { render } from "./RDFChoiceView.vue?vue&type=template&id=06fd6670&scoped=true"
import script from "./RDFChoiceView.vue?vue&type=script&lang=js"
export * from "./RDFChoiceView.vue?vue&type=script&lang=js"

import "./RDFChoiceView.vue?vue&type=style&index=0&id=06fd6670&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fd6670"]])

export default __exports__